/*----------------------------------
- MENU COUNT ROW
----------------------------------*/

/*----------------------------------
- TYPES
----------------------------------*/

type MenuCountRowProps = {
    href: string;
    label: string;
    /** Formatted backend count. Null when Product sent none: the row then shows the label alone. */
    count: string | null;
    ariaLabel?: string;
    onClick?: () => void;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

/** One ending or one sector in the Domains menu: its name on the left, its count on the right. */
export default function MenuCountRow({ href, label, count, ariaLabel, onClick }: MenuCountRowProps) {
    return (
        <a
            href={href}
            onClick={onClick}
            aria-label={ariaLabel}
            class="-mx-2.5 flex items-center justify-between gap-3 rounded-[10px] px-2.5 py-[9px] text-[15px] transition-colors hover:bg-[#f0ede6]"
        >
            <span class="font-semibold text-slate-950">{label}</span>
            {count ? <span class="text-[13px] font-semibold tabular-nums text-[#66696b]">{count}</span> : null}
        </a>
    );
}
